/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared';
import {
  TGetQuestionListModel,
  IGetQuestionListRequest,
  IMappers,
  IGetQuestionListResponse,
  IGetQuestionListResponseError,
  TGetQuestionListResponse,
} from './types';

const defaultConfig: TGetQuestionListModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'GET',
  microserviceName: 'journal',
  pathApi: '/v2/get-question-list/',
  hostType: 'api',
} as TGetQuestionListModel;

function createGetQuestionListModel(parameters: IGetQuestionListRequest): TGetQuestionListModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetQuestionListOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: IGetQuestionListRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchGetQuestionList<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: IGetQuestionListOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TGetQuestionListResponse
> {
  const { response, statusCode } = await httpApi.fetch(createGetQuestionListModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetQuestionListResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as IGetQuestionListResponseError);
    }
  }

  return { response, statusCode } as TGetQuestionListResponse;
}

export { defaultConfig, createGetQuestionListModel, fetchGetQuestionList };
